import createModule from "../createModule"
import view from "./view"
import { getSortOrder } from "modules/factor-trends/selectors"
import { getDetails, getCsvData } from "./selectors"
import { Creators } from "./model"
import { Creators as ProfileCreators } from "model/profileModal"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    details: getDetails(state, props),
    csvData: getCsvData(state, props),
    order: getSortOrder(state, props),
  }),
  actions: {
    ...Creators,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
